import { render, staticRenderFns } from "./DeliveryDateDashboard.vue?vue&type=template&id=56949991&"
import script from "./DeliveryDateDashboard.vue?vue&type=script&lang=js&"
export * from "./DeliveryDateDashboard.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDateDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports